
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15 10.6V5C15 3.34 13.66 2 12 2C10.46 2 9.20998 3.16 9.03998 4.65L15 10.6ZM18.08 11C17.67 11 17.31 11.3 17.25 11.71C17.2 12.03 17.13 12.35 17.03 12.64L18.3 13.91C18.6 13.31 18.82 12.66 18.93 11.97C19 11.46 18.6 11 18.08 11ZM3.70998 3.56C3.31998 3.95 3.31998 4.58 3.70998 4.97L8.99998 10.27V10.7C8.99998 11.89 9.59998 13.02 10.63 13.61C11.38 14.04 12.04 14.05 12.65 13.92L14.31 15.58C13.6 15.91 12.81 16.1 12 16.1C9.45998 16.1 7.11998 14.33 6.74998 11.71C6.68998 11.3 6.32998 11 5.91998 11C5.39998 11 4.99998 11.46 5.06998 11.97C5.52998 14.93 8.02998 17.27 11 17.72V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V17.72C13.91 17.59 14.77 17.27 15.55 16.82L19.04 20.31C19.43 20.7 20.06 20.7 20.45 20.31C20.84 19.92 20.84 19.29 20.45 18.9L5.11998 3.56C4.72998 3.17 4.09998 3.17 3.70998 3.56Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-mic-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMicOff

    ```js
    <b-new-b-icon-mic-off />
    ```
</docs>


